import { EmailTemplatePlaceholder } from "./emailTemplates.types";

export const EMAIL_TEMPLATE_PLACEHOLDERS: EmailTemplatePlaceholder[] = [
  { key: "firstName", label: "First name", token: "{{firstName}}" },
  { key: "lastName", label: "Last name", token: "{{lastName}}" },
  { key: "companyName", label: "Company name", token: "{{companyName}}" },
];
